import React from 'react'
import styled from '@emotion/styled'
import { LoadingOutlined } from '@ant-design/icons'
import { PrimaryButton } from '../styles'

// visibility, not display: the hidden label must keep reserving its width.
const ButtonLabel = styled.span<{ $hidden?: boolean }>(
  ({ $hidden }) => `
  visibility: ${$hidden ? 'hidden' : 'visible'};
`
)

const ButtonSpinner = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

interface LoadingPrimaryButtonProps {
  loading?: boolean
  disabled?: boolean
  onClick: () => void
  children: React.ReactNode
}

// Spinner replaces the label in place, rather than antd's icon-beside-text, so
// the button keeps its width between idle and loading.
const LoadingPrimaryButton = ({
  loading,
  disabled,
  onClick,
  children
}: LoadingPrimaryButtonProps) => (
  <PrimaryButton disabled={disabled} onClick={onClick}>
    <ButtonLabel $hidden={loading}>{children}</ButtonLabel>
    {loading && (
      <ButtonSpinner>
        <LoadingOutlined spin />
      </ButtonSpinner>
    )}
  </PrimaryButton>
)

export default LoadingPrimaryButton
